// Import everything from autoload
//~ import './autoload/lightgallery';
//~ import './autoload/lightslider.min';
//~ import './autoload/lg-thumbnail.min';
//~ import './autoload/lg-hash.min';
//~ import './autoload/lg-zoom.min';
//~ import './autoload/a11y-tabs';
import { initGallery } from './gallery.js';

// fire when document is ready
document.addEventListener('DOMContentLoaded', function() {
  // handle menus dropdown
  document.getElementById('navbar-toggler').addEventListener('click', function(event) {
    const nav = document.getElementById('main-nav_container');
    const status = (nav.getAttribute('data-status') === 'hidden')
      ? 'visible'
      : 'hidden';
    event.target.setAttribute('data-status', status);
    nav.setAttribute('data-status', status);
  });

  function toggleDropdown(link, expanded) {
    const dropdown = link.nextElementSibling;
    if (typeof expanded === 'undefined') {
      expanded = (dropdown.getAttribute('aria-expanded') || '').includes('true');
    }
    dropdown.setAttribute('aria-expanded', !expanded);
    link.setAttribute('data-active', !expanded);
  }

  const dropdowns = document.querySelectorAll('[data-component=dropdown]');
  for (let i=0; i<dropdowns.length; i++) {
    const link = dropdowns[i];
    link.addEventListener('click', function() {
      toggleDropdown(link);
    });
    link.addEventListener('mouseover', function() {
      toggleDropdown(link,false);
    });
    link.addEventListener('mouseout', function() {
      toggleDropdown(link,true);
    });
  }

  // handle back-to-top button
  const toTop = document.getElementById('toTop');
  const screenHeight = window.innerHeight;
  window.addEventListener('scroll', function() {
    const toTopShown = (window.scrollY > screenHeight/2);
    const isVisible = (toTop.getAttribute('class') || '').includes('toTop-visible')
    if (isVisible && !toTopShown) {
      toTop.setAttribute('class', '');
    } else if (!isVisible && toTopShown) {
      toTop.setAttribute('class', 'toTop-visible');
    }
  });

  initGallery();


  // CAROUSELS TMH
  // Pour chaque carousel(s) trouvé(s), on veut lancer automatiquement ce dernier. Si un utilisateur click sur une des flèches, on arrête le slider automatique et l'utilisateur peur faire défiler à sa guise.
  (() => {
    /** Ensemble des carousels de la page */
    let carousels = document.querySelectorAll('.wp-block-gco-carousel');
    /** Boucle sur chaque carousel... */
    for(let i=0; i < carousels.length; i++) {
      /** ```<div class="carousel">``` */
      const carousel = carousels[i].querySelector('.carousel');
      /** ```<ul class="inner-carousel">``` */
      const innerCarousel = carousel.querySelector('.inner-carousel');
      /** Mode de défilement du slider
       * ```
       *  * true: slide
       *  * false: fade
       * ```
       */
      const isSlide = carousel.classList.contains('slide'); // Si true: "slide" sinon "fade"
      /** Style des bouttons permettant le défilement manuel du slider
       * ```
       *  * true: fleches
       *  * false: bulles
       * ```
       */
      const isFleche = typeof carousel.querySelectorAll('.fleches')[0] === 'object';
      /** Flèches du carousel */
      const fleches = carousel.querySelectorAll('.fleches');
      /** Flèche Précédente */
      const arrowL = fleches[0];
      /** Flèche Suivante */
      const arrowR = fleches[1];

      /** Nombre d'éléments dans le carousel */
      const nbElements = () =>  parseInt(innerCarousel.dataset.nbelements);
      /** Nombre d'image affichées en même temps dans le carousel */
      const images = () => parseInt(getComputedStyle(carousels[i]).getPropertyValue('--images'));
      /** **maxNumSlide + 1** correspond au nombre de slide possible à affiché. Il dépend du nombre d'éléments dans le carousel et le nombre d'images visible en même temps. */
      const maxNumSlide = () => Math.ceil(nbElements()/images()) - 1;
      /** Numéro du slide en cours */
      const currentSlide = () => parseInt(innerCarousel.dataset.numslide);
      /** Met à jour l'attribut possédant le numéro du slide en cours */
      const actualiseNumSlide = (numero) => innerCarousel.dataset.numslide = numero;
      /** Sens de rotation du slider (avance/recul) */
      const sensTranslate = () => innerCarousel.dataset.senstranslate;
      /** Met à jour l'attribut possédant le sens de rotation du slider */
      const actualiseSensTranslate = value => innerCarousel.dataset.senstranslate = value;
      /** Boutons du slider (bulles ou flèches) */
      const btnRadios = carousel.querySelectorAll('.radio-carousel button');

      /** Applique une translation sur ```<ul class="inner-carousel">``` */
      const applyTranslation = (numSlide) => {
        const wrapperWidth = carousel.clientWidth;
        let oneTranslate = wrapperWidth +  parseInt(getComputedStyle(carousels[i]).getPropertyValue('--gap'));
        innerCarousel.setAttribute('style', 'transform: translate3D(calc(-1 * '+ oneTranslate +'px * '+numSlide+'),0,0);');
      };
      /** Applique l'opacité approprié sur les éléments du carousel */
      const applyOpacity = (numSlide) => {
        const lis = innerCarousel.querySelectorAll('li');
        lis.forEach(li => li.style.opacity = 0);
        const firstImageSlide = images() * numSlide;
        const lastImageSlide = firstImageSlide + images() - 1;
        for (let i = firstImageSlide; i <= lastImageSlide; i++) {
          if (i < nbElements()) (lis[i].style.opacity = 1);
        }
      };
      /** Applique le type de mouvement adéquate en fonction du type de carousel (slide ou fade) */
      const runMouvement = () => {
        if (isSlide) (applyTranslation(currentSlide()));
        else (applyOpacity(currentSlide()));
      }
      /** Ajout un écouteur d'évènement click sur les bulles */
      const listenerBtnRadios = (runSlide) => {
        btnRadios.forEach((btn) => {
          btn.onclick = (e) => {
            if (e.isTrusted) { clearInterval(runSlide); }
            btnRadios.forEach(btn => btn.setAttribute('class', ''));
            e.target.setAttribute('class', 'bg-primary-500');
            if (isSlide) (applyTranslation(e.target.dataset.index/images()));
            else (applyOpacity(e.target.dataset.index/images()))
          }
        });
      };

      /** Tout type de carousel */
      innerCarousel.dataset.senstranslate = 'avance';
      const recule = () => {
        if (isFleche && currentSlide() === maxNumSlide()) (arrowR.style.display = 'block');
        if (currentSlide() === 1) {
          if (isFleche) (arrowL.style.display = 'none');
          actualiseSensTranslate('avance')
        }
        actualiseNumSlide(currentSlide() - 1);
        runMouvement();
      };
      const avance = () => {
        if (isFleche && currentSlide() === 0) (arrowL.style.display = 'block');
        if (currentSlide() + 1 === maxNumSlide()) {
          actualiseSensTranslate('recule');
          if (isFleche) (arrowR.style.display = 'none');
        }
        actualiseNumSlide(currentSlide() + 1);
        runMouvement();
      };


      /** Fade */
      /** Affiche la première ligne d'image des carousels Fade. */
      if (!isSlide) (applyOpacity(0));

      /** Bulles */
      /** Ecoute les click sur les bouttons radios qui déclencheront le mouvement de slide voulu. */
      if (!isFleche) { 
        /** Démarrage automatique du slider en mode "slide" ou "fade" */
        const runSlide = setInterval(
          function () {
            if (sensTranslate() === 'avance') (avance());
            else (recule());
            btnRadios.forEach(btn => btn.setAttribute('class', ''));
            btnRadios[currentSlide() * images()].setAttribute('class', 'bg-primary-500');
          }, 5000
        );
        runSlide;
        if (nbElements() <= images()) (clearInterval(runSlide));
        listenerBtnRadios(runSlide); 
        continue; 
      }

      /** Flèches */
      if (isFleche) {
        arrowL.style.display = 'none';
        if (nbElements() <= images()) (arrowR.style.display = 'none');

        /** Démarrage automatique du slider en mode "slide" ou "fade" */
        const runSlide = setInterval(
          function () {
            if (sensTranslate() === 'avance') (avance());
            else (recule());
          }, 5000
        );
        runSlide;
        if (nbElements() <= images()) (clearInterval(runSlide));

        arrowL.onclick = e => {
          if (e.isTrusted) { clearInterval(runSlide); }
          recule();
        };

        arrowR.onclick = e => {
          if (e.isTrusted) { clearInterval(runSlide); }
          avance();
        };
      }
    }
  })();
}, false);


// WEBPACK FOOTER //
// ./scripts/main.js